<template lang="pug">
  v-menu(
    offset-y,
    min-width='290px',
    transition='scale-transition',
    v-model='show',
    :close-on-content-click='false',
    :nudge-top="nudgeTop",
  )
    template(v-slot:activator='{ on }')
      v-text-field(
        autocomplete="off",
        prepend-icon='far fa-calendar-alt',
        :clearable="allowEmpty",
        :hide-details="hideDetails",
        :label="label",
        :rules="rules",
        :value="value",
        v-bind="$attrs",
        v-mask="mask",
        @keydown.stop,
        @click='show = true',
        @input="$emit('update:value', $event)",
        @click:clear="$emit('update:value', null)",
      )
    v-date-picker(
      :range="$attrs.range",
      :value='formattedDate',
      @input="formattedDate = $event",
    )
</template>

<script>
import { isNil } from 'ramda';
import { mask } from 'vue-the-mask';
import { validateDate, formatDate } from '@/utils/helper';
import DateText from '@/components/forms/inputs/DateText.vue';

export default {
  props: {
    allowEmpty: {
      type: Boolean,
      default: false,
    },

    hideDetails: {
      type: Boolean,
      default: false,
    },

    nudgeTop: {
      type: Number,
      default: 23,
    },

    label: {
      type: String,
      default: 'Date',
    },

    value: {
      validator: prop => typeof prop === 'string' || prop === null,
      required: true,
    },
  },

  components: {
    DateText,
  },

  directives: {
    mask,
  },

  data: () => ({
    show: false,
    mask: '##/##/####',
    rules: [
      v => !!v || 'date is required',
      v => {
        return validateDate(v) || 'Invalid format';
      },
    ],
  }),

  created() {
    if (this.allowEmpty) {
      this.rules = [
        v => {
          return validateDate(v) || v === null || 'Invalid format';
        },
      ];
    }
  },

  computed: {
    formattedDate: {
      get() {
        if (!validateDate(this.value)) {
          return null;
        }
        if (isNil(this.value) || this.value === '') {
          return null;
        }
        const [dd, mm, yyyy] = this.value.split('/');

        return `${yyyy}-${mm}-${dd}`;
      },

      set(val) {
        const [yyyy, mm, dd] = val.split('-');
        this.$emit('update:value', `${dd}/${mm}/${yyyy}`);
        this.show = false;
      },
    },
  },
};
</script>
